import * as React from 'react';
import { styled } from 'styled-components';
import { Drawer } from '@mui/material';
import { RadioGroup, RadioGroupChangeEvent } from '@progress/kendo-react-inputs';
import { sectionPadding, tabletPortraitMinWidth } from '../../appComponents/cssConstants';
import { DrawerHeaderStyle, DrawerPaperStyles, SpanStyled, TabletPortraitStyles } from './BottomModal';
import { LeftBlueOrWhiteIconForModal } from '../../appComponents/pages_v2/common/LeftBlueOrWhiteIcon';
import CloseButton from './CloseButton';
import { convertDropDownToLabelValueOption } from '../../lib/utils';
import { DropDownListOption } from '../../models/DropDownListOption';

const BottomListModal = ({
	open,
	onClose,
	title,
	data,
	name,
	value,
	onChange,
	showBackButton = true,
	showCloseButton = true
}: Props) => {
	// Convert the data from DropDownListOption<T> to LabelValueOption<T> format
	const convertedData = convertDropDownToLabelValueOption(data);

	return (
		<StyledDrawer anchor="bottom" open={open} onClose={onClose}>
			<DrawerHeader>
				{showBackButton && <LeftBlueOrWhiteIconForModal onClick={onClose} />}
				<DrawerHeaderTitle>{title}</DrawerHeaderTitle>
				{showCloseButton && (
					<Styledspan>
						<CloseButton onClick={onClose} />
					</Styledspan>
				)}
			</DrawerHeader>
			<StyledRadioGroup data={convertedData} name={name} value={value ?? ''} onChange={onChange} />
		</StyledDrawer>
	);
};

export default BottomListModal;

interface Props {
	open: boolean;
	onClose: () => void;
	title: string;
	data: DropDownListOption<string | number>[];
	name: string;
	value: string | number;
	onChange: (e: RadioGroupChangeEvent) => void;
	showBackButton?: boolean;
	showCloseButton?: boolean;
}

export const StyledDrawer = styled(Drawer)`
	.MuiDrawer-paper {
		${DrawerPaperStyles()};
		padding: 5px 20px 25px 20px;
	}

	@media (min-width: ${tabletPortraitMinWidth}) {
		&& .MuiDrawer-paper {
			${TabletPortraitStyles}
		}
	}
`;

const DrawerHeader = styled.div`
	${DrawerHeaderStyle}
	margin-bottom: ${sectionPadding};
`;

const DrawerHeaderTitle = styled.p`
	font-size: 16px;
	font-weight: 600;
	line-height: 24px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 18px;
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
	}
`;

export const StyledRadioGroup = styled(RadioGroup)`
	width: 100%;
	flex-flow: column nowrap;
	border: 1px solid #c6c3c3;
	border-radius: 10px;
	padding: 5px 20px;

	.k-radio-list-item {
		display: flex;
		gap: 10px;
		padding: 12px 0;
		height: 56px;
		border-bottom: 0.5px solid #c6c3c3;
		font-size: 14px;
		line-height: 20px;
		font-weight: 400;

		&:last-child {
			border-bottom: none;
		}

		.k-radio-label {
			width: 100%;
			height: 100%;
			line-height: 32px;
		}
	}

	.k-radio-wrap {
		margin: auto 0;

		.k-radio {
			border-color: #666;

			&:checked {
				border-color: ${(props) => props.theme.brandingColourHeavy};
				background-color: ${(props) => props.theme.brandingColourHeavy};

				&:focus {
					box-shadow: none;
				}
			}
		}
	}
`;

export const Styledspan = styled.span`
	${SpanStyled}
`;
